import { Loader } from "@googlemaps/js-api-loader"

export default new Loader({
  apiKey: process.env.NODE_ENV === 'production' ? "AIzaSyDlDrNURMr7SVifjvIJXqIvdZw1XO_QjWk" : "",
  version: "weekly",
  // ...additionalOptions,
});